<script setup lang="ts">
import { consola } from 'consola'

const eventSource = ref<EventSource | null>(null)

const showMaintenanced = useState<boolean>('showMaintenanced', () => false)

callOnce(async () => {
  if (import.meta.client) {
    showMaintenanced.value = await genMaintenance()
    if (showMaintenanced.value) {
      setPageLayout('empty')
    }
  }
})

function connectSSE() {
  // 连接 SSE 端点
  eventSource.value = new EventSource('/api/sse')

  // 监听消息
  eventSource.value.onmessage = async (e) => {
    const data = JSON.parse(e.data)
    if (data.hasChanged && data.exists) {
      // 执行 UI 更新逻辑（如刷新数据、提示用户等）
      showMaintenanced.value = await genMaintenance()
      if (showMaintenanced.value) {
        setPageLayout('empty')
      }
    }
  }

  // 错误处理
  eventSource.value.onerror = (e) => {
    consola.info('SSE 连接错误:', e)
    eventSource.value?.close()
    eventSource.value = null
    consola.info('SSE 连接错误，5秒后重试...')
    setTimeout(() => {
      connectSSE()
    }, 5000)
  }
}

onMounted(connectSSE)
</script>

<template>
  <NuxtLoadingIndicator color="#f3f3f3" :throttle="300" :duration="500" :height="2" />
  <NuxtRouteAnnouncer />
  <template v-if="!showMaintenanced">
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </template>
  <template v-else>
    <img style="width: 100vw; height: 100vh;" src="/down.png" alt="">
  </template>
</template>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

/* 设置滚动条 */
::-webkit-scrollbar {
  width: 1px;
  height: 5px;
}
html,
body {
  /* ios 禁止橡皮筋效果 */
  overscroll-behavior-y: none;
  -webkit-overflow-scrolling: touch;
  /* 设置滚动条 */
  scrollbar-width: thin;
  scrollbar-color: #d9d9d9 transparent;
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  background-color: #d9d9d9;
  border-radius: 5px;
}

/* 滚动条轨道 */
::-webkit-scrollbar-track {
  background-color: transparent;
}
</style>
